import {
	Button,
	Checkbox,
	Chip,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Icon,
	MenuItem,
	TextField,
	Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { AccountCircle, Pets } from '@material-ui/icons'
import moment from 'moment'
import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { getParkingCodes } from '../../actions/checkIns/checkins.actions'
import { showError, showSuccess } from '../../actions/misc/misc.actions'
import CheckInAutocomplete from '../Autocompletes/CheckIn'
import { api } from '../../services/api'
import { getChipStyles } from '../../services/helpers'
import {
	householdHasVIPTrial,
	validateNoPassCheckIn,
	BAR_VIP_MEMBERSHIP_TYPES,
	setDateToMidday,
	PROMO_API_ACTIONS,
	PROMO_SERVICE_TARGETS,
	getValidMemberships,
	NON_BREAKING_SPACE,
	calculatePromoAmountToApply
} from '../../utils'
import { AccessMethod } from '../Misc/AccessMethod'
// import { BarDues } from '../Misc/BarDues'
import LoadingOverlay from '../Misc/LoadingOverlay'
import { Parking } from '../Misc/Parking'
import PromoAndDiscountEntryDialog from './Promos/PromoAndDiscountEntryDialog'
import { purple, gray, dangers, errors } from '../../utils/colors'

const useStyles = makeStyles(() => ({
	close: {
		position: 'absolute',
		color: gray[700],
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 16,
		cursor: 'pointer'
	},
	dialog: {
		'& .MuiDialog-paper': {
			width: 920,
			maxWidth: 1000
		}
	},
	dialogActions: {
		justifyContent: 'space-between',
		padding: '16px 24px',
		borderTop: `1px solid ${gray[500]}`
	},
	line: {
		marginTop: '8px',
		marginBottom: 8,
		height: 1,
		border: `1px solid ${gray[500]}`
	},
	header: {
		marginBottom: 12,
		'& h2': {
			textTransform: 'uppercase',
			fontWeight: '800',
			fontSize: '16px !important'
		}
	},
	visitorContainer: {
		display: 'flex',
		flexDirection: 'column',
		paddingBottom: '24'
	},
	visitor: {
		marginBottom: '16px',
		background: gray[200],
		borderRadius: '6px',
		display: 'flex',
		flexDirection: 'row',
		overflow: 'hidden'
	},
	visitorImage: {
		width: '88px',
		height: '88px'
	},
	visitorPicture: {
		width: '88px',
		height: '88px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '6px 0px 0px 0px',
		overflow: 'hidden',
		backgroundColor: purple[200]
	},
	visitorPictureGuest: {
		width: '88px',
		height: '88px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '6px 0px 0px 6px',
		overflow: 'hidden',
		backgroundColor: purple[200]
	},
	guestText: {
		fontSize: 16,
		fontWeight: '800',
		color: gray[100]
	},
	pic: {
		height: '100%',
		width: '100%'
	},
	vistorDetails: {
		height: 88,
		paddingLeft: 16,
		paddingRight: 16,
		width: 'auto',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: 250,
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap'
	},
	visitorEligibility: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		paddingTop: 8,
		width: '50%'
	},
	eligibilityText: {
		color: gray[800],
		fontSize: 12,
		fontWeight: '800',
		letterSpacing: 0.75,
		textTransform: 'uppercase'
	},
	vistorName: {
		display: 'flex',
		alignItems: 'center',
		paddingTop: '0px'
	},
	vistorRemove: {
		display: 'flex',
		flex: 1,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		paddingRight: 16,
		alignItems: 'flex-start',
		paddingTop: '24px'
	},
	vistorSubtitle: {
		paddingTop: '0px',
		color: gray[700],
		fontSize: '14px',
		fontWeight: '600'
	},
	grid: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		width: '60%'
	},
	receipt: {
		width: '40%',
		paddingLeft: 16,
		paddingRight: 16
	},
	summaryContainer: {
		width: '100%',
		backgroundColor: gray[200],
		borderRadius: 6,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		padding: 16
	},
	summaryHeaderContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		border: `0px 0px 1px 0px solid ${gray[300]}`,
		paddingBottom: 16,
		marginBottom: 16
	},
	summaryHeader: { fontWeight: '800', fontSize: 16, color: gray[900] },
	row: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		paddingBottom: 8
	},
	rowHeader: {
		fontWeight: '800',
		fontSize: 12,
		letterSpacing: 0.75,
		opacity: 0.75,
		color: gray[900]
	},
	rowText: {
		fontSize: 14,
		color: gray[900],
		lineHeight: '24px'
	},
	col1: {
		width: '55%'
	},
	col2: {
		width: '20%'
	},
	col3: {
		width: '25%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end'
	},
	chip: {
		'& > span': { marginRight: '0px' }
	},
	addPromoDiscountButton: { color: purple[500], paddingLeft: 0, marginBottom: 10 },
	removePromoDiscountButton: { color: dangers[500], paddingLeft: 0, marginBottom: 10 },
	hyperLink: {
		textDecoration: 'none',
		marginLeft: '8px',
		color: purple[500],
		fontSize: '16px',
		fontWeight: '800'
	}
}))

const getDayPassPricingForFacility = (facility) => {
	const testDates = ([start, end]) => {
		const now = setDateToMidday(moment())
		const nowString = now.format('MM/DD/YY')
		const startDate = setDateToMidday(moment(start))
		const startString = startDate.format('MM/DD/YY')
		const endDate = setDateToMidday(moment(end))
		const endString = endDate.format('MM/DD/YY')

		const matchesStart = nowString === startString
		const matchesEnd = nowString === endString
		const isBetween = moment(now).isBetween(startDate, endDate)

		return matchesStart || matchesEnd || isBetween
	}

	const { special_daypass_prices = [], daypass_prices } = facility
	const specialPricing = special_daypass_prices.find(({ start_date, end_date }) => {
		return testDates([start_date, end_date])
	})

	if (specialPricing) {
		return specialPricing
	}

	const day = moment().subtract(5, 'hours').format('dddd')
	return daypass_prices[day]
}

const PAYMENT_TYPES = ['Charge Account', 'Point of Sale']
const DEFAULT_ENTRY = {
	charge_type: '',
	access_type: '',
	number: ''
}
const DEFAULT_DAYPASS_PRICE = {
	day_pass_price: 0,
	additional_pet_price: 0
}

const VISITOR_TYPES = {
	Guest_No_Dog: 'Guest (no dog)',
	Guest_With_Dog: 'Guest (with Dog)',
	Contact: 'Contact'
}

const CheckInDialog = ({
	addNewVisitor,
	checkIn,
	completeBadCheckIn,
	completeCheckIn,
	// checkinId,
	date,
	facility,
	guestSigned,
	isShown,
	membershipTypes,
	parking_codes,
	parkingCode,
	petsInFacility,
	refreshList,
	removeAccount,
	removeGuest,
	removePet,
	setCodeOnCheckIn,
	setIsShown,
	singleLoading,
	unselect
}) => {
	if (!checkIn) {
		return null
	}

	const classes = useStyles()
	const dispatch = useDispatch()
	const [entry, setEntry] = useState(DEFAULT_ENTRY)
	const [dayPassPrice, setDayPassPrice] = useState(DEFAULT_DAYPASS_PRICE)
	const [visitor_type, setVisitorType] = useState('Guest')
	const [appliedPromo, setAppliedPromo] = useState(null)
	const [appliedManualDiscount, setAppliedManualDiscount] = useState(null)
	const [showPromoDiscountEntry, setShowPromoDiscountEntry] = useState(false)
	const [cards, setCards] = useState([])
	const [cardsLoaded, setCardsLoaded] = useState(false)
	const [chargeSuccess, setChargeSuccess] = useState(false)
	const [menuOpen, openMenu] = useState(false)
	const [newVisitor, setNewVisitor] = useState()
	const [duesNeeded, setDuesNeeded] = useState([])
	const [humanGuest, setGuest] = useState()
	const [guestDogs, setGuestDogs] = useState([])

	const checkin_id = checkIn._id || ''
	const numDogs = checkIn.pets?.length || 0
	// const shouldChargeForFirstCheckin = facility?.market?.city === 'Denver' || false
	const shouldChargeForFirstCheckin = false
	const { needsPass, hasDayPass } = validateNoPassCheckIn(checkIn, shouldChargeForFirstCheckin, facility?.market)
	const isVipTrial = householdHasVIPTrial(checkIn.memberships)
	const validMemberships = getValidMemberships(checkIn.memberships, BAR_VIP_MEMBERSHIP_TYPES)
	const visitorOptions = [VISITOR_TYPES.Contact, VISITOR_TYPES.Guest_No_Dog, VISITOR_TYPES.Guest_With_Dog]
	const disabledCozDateBefore = moment(date).isBefore(moment(), 'date')
	const missingTransactionId =
		entry.charge_type === 'Point of Sale' && (!entry.transaction_id || entry.transaction_id === '')

	const showParkingSection = facility?.market?.city === 'Charlotte' || false

	const showNumDogs = facility?.market?.city === 'Charlotte' || false

	useEffect(() => {
		if (facility) {
			const pricing = getDayPassPricingForFacility(facility)
			setDayPassPrice(pricing)
		}
	}, [facility])

	useEffect(() => {
		dispatch(getParkingCodes(checkin_id))
	}, [checkin_id])

	useEffect(() => {
		// let accts = []
		if (checkIn?._id) {
			loadPayment()
			setEntry({ charge_type: PAYMENT_TYPES[0], access_type: 'day_pass', number: numDogs })
		}
	}, [checkIn])

	const handleShowPromoDiscountEntryDialog = () => {
		setShowPromoDiscountEntry(true)
	}

	const handleHidePromoDiscountEntryDialog = () => {
		setShowPromoDiscountEntry(false)
	}

	const getCode = async (checkin_id) => {
		return new Promise(async (resolve, rej) => {
			try {
				// console.log('getting code...')
				const { data } = await api.get(`/facilities/parkingCode?checkin_id=${checkin_id}`)
				let code = data?.code ? data.code : null
				if (code) dispatch({ type: 'UPDATE_PARKING_CODE', payload: code })
				resolve(code)
			} catch (e) {
				console.log('big ol e...', e)
				rej(e)
			}
		})
	}

	const updateAccessMethodAndCheckIn = () => {
		let updates
		if (checkIn.memberships && checkIn.memberships.length > 0) {
			let membership = checkIn.memberships[0]
			let access_method = membership.type + ' membership'
			if (membership.type === 'monthly') access_method = 'Monthly Pass'

			updates = {
				_id: checkIn._id,
				access_method: access_method,
				membership_id: membership._id,
				guests: checkIn.guests
			}
		} else {
			if (checkIn.day_passes && checkIn.day_passes.length > 0) {
				let dayPass = checkIn.day_passes[0]
				updates = {
					_id: checkIn._id,
					access_method: 'Day Pass',
					daypass_id: dayPass._id,
					guests: checkIn.guests
				}
			} else if (checkIn.checked_in) {
				updates = {
					_id: checkIn._id,
					guests: checkIn.guests
				}
			} else {
				updates = { _id: checkIn._id, access_method: 'N/A', guests: checkIn.guests }
			}
		}
		// console.log(updates)
		updates.date = moment().format('MM-DD-YYYY')
		updates.checkin_time = moment()
		if (parkingCode) updates.parking_code = parkingCode

		if (checkIn.guest_passes) {
			updates.guest_passes = checkIn.guest_passes
		}

		console.log('updates...', updates)

		completeCheckIn(updates)
		resetAll()
	}

	const loadPayment = async () => {
		try {
			let { data } = await api.get(`/getPaymentInfo/${checkIn.household_id}`, {
				params: facility?._id ? { facility_id: facility._id } : undefined
			})
			setCards(data)
			setCardsLoaded(true)
		} catch (e) {
			console.log('big ol e...', e)
			dispatch(showError('Cards not found'))
		}
	}

	const getAddVisitorSelector = () => {
		if (visitor_type === VISITOR_TYPES.Contact) {
			let findVis = newVisitor ? checkIn.extra_contacts.find((c) => c._id == newVisitor._id) : ''
			let name = findVis ? findVis.full_name : ''
			return (
				<TextField
					variant="filled"
					value={findVis || ''}
					label="Contact"
					select
					style={{ width: '48%', marginBottom: 16, minWidth: 5 }}
					onChange={(e) => {
						setNewVisitor(e.target.value)
					}}
					InputProps={{
						style: {
							width: '100%',
							minWidth: 240
						}
					}}>
					{checkIn.extra_contacts.map((contact) => (
						<MenuItem key={contact._id} value={contact}>
							{contact.full_name}
						</MenuItem>
					))}
				</TextField>
			)
		}

		if (visitor_type === VISITOR_TYPES.Guest_No_Dog) {
			return (
				<TextField
					variant="filled"
					value={newVisitor ? newVisitor.name : ''}
					label="Guest Name"
					style={{ width: '48%', marginBottom: 16, minWidth: 5 }}
					onChange={(e) => {
						setNewVisitor({ name: e.target.value, type: 'guest' })
					}}
					InputProps={{
						style: {
							width: '100%',
							minWidth: 240
						}
					}}
				/>
			)
		}

		if (visitor_type === VISITOR_TYPES.Guest_With_Dog) {
			return null
		}

		if (visitor_type === VISITOR_TYPES.Dog) {
			let findPet = newVisitor ? checkIn.extra_pets.find((c) => c._id == newVisitor._id) : ''
			const availablePets = checkIn.extra_pets.filter(
				(pet) => pet.animal_type && pet.animal_type.toLowerCase() === 'dog'
			)
			return (
				<TextField
					variant="filled"
					value={findPet || ''}
					label="Dog"
					select
					style={{ width: '48%', marginBottom: 16, minWidth: 5 }}
					onChange={(e) => {
						setNewVisitor(e.target.value)
					}}
					InputProps={{
						style: {
							width: '100%',
							minWidth: 240
						}
					}}>
					{availablePets.map((pet) => (
						<MenuItem key={pet._id} value={pet}>
							{pet.name}
						</MenuItem>
					))}
				</TextField>
			)
		}
	}

	const chargeAccount = async () => {
		try {
			dispatch({ type: 'CHECKIN_LOADING' })
			let obj = {
				...entry,
				needs_daypass: needsPass ? true : false,
				validated_promo: appliedPromo ? appliedPromo : null,
				manual_discount: appliedManualDiscount ? appliedManualDiscount : null,
				checkin_id: checkIn._id,
				household_id: checkIn.household_id,
				facility_id: facility._id,
				duesNeeded: duesNeeded
			}

			if (validMemberships.length && guestDogsArr.length) {
				obj.guest_passes = guestDogsArr.length
			}

			await api.post(`/checkIn/charge`, obj)
			refreshList()
			if (entry.charge_type === 'Charge Account') {
				setChargeSuccess(true)
				setTimeout(() => {
					setChargeSuccess(false)
				}, 4000)
			}
		} catch (e) {
			console.log('big ol e...', e)
			dispatch(showError(e?.data?.message || 'Error charging account'))
			dispatch({ type: 'CHECKIN_NOT_LOADING' })
		}
	}

	const getNewMethod = () => {
		if (
			(validMemberships.length && !guestDogsArr.length) ||
			checkIn.day_passes.length ||
			checkIn.checked_in ||
			(!checkIn.pets.length && !duesNeeded.length)
		) {
			return null
		}

		// if (checkIn.pets.length === 0) return 'N/A'

		let day_pass_price = dayPassPrice.day_pass_price
		let additional_pet_price = dayPassPrice.additional_pet_price

		let dayPass = {
			type: 'day_pass',
			name: 'Day Pass',
			price: day_pass_price,
			additional_pet_fee: additional_pet_price
		}

		if (validMemberships.length && guestDogsArr.length) {
			if (checkIn?.guest_passes?.length) return null

			dayPass = {
				type: 'day_pass',
				name: 'Guest Pass',
				price: 500 * guestDogsArr.length
			}
		}

		let isChargeDisabled = false
		let payingForPassOrMembership = entry.access_type ? true : false

		if (checkIn?.pets?.length > 0 && payingForPassOrMembership) {
			if (!entry.charge_type || !entry.access_type || !entry.number) {
				isChargeDisabled = true
			}
		}

		if (entry?.charge_type === 'Charge Account' && !cards.length) {
			isChargeDisabled = true
		}

		if (!entry.charge_type) isChargeDisabled = true
		const total = getTotal().value

		let types = [dayPass]
		return (
			<div>
				<Typography
					className={classes.reportHeader}
					style={{
						fontSize: 16,
						fontWeight: '800',
						textTransform: 'capitalize',
						marginBottom: 16,
						marginRight: 12,
						marginTop: 16
					}}>
					Payment
				</Typography>
				<div style={{ display: 'flex', flexDirection: 'row', paddingBottom: 36 }}>
					<div className={classes.grid}>
						<TextField
							variant="filled"
							disabled={disabledCozDateBefore}
							value={entry.charge_type || ''}
							label="Payment Type"
							select
							style={{ width: '100%', marginBottom: 16 }}
							onChange={(e) => {
								setEntry({ ...entry, charge_type: e.target.value })
							}}>
							{PAYMENT_TYPES.map((option) => (
								<MenuItem key={option} value={option}>
									{option}
								</MenuItem>
							))}
						</TextField>

						{entry.charge_type === 'Point of Sale' ? (
							<TextField
								variant="filled"
								disabled={disabledCozDateBefore}
								required
								value={entry.transaction_id || ''}
								style={{ marginBottom: 16, minWidth: 240, width: '100%' }}
								InputProps={{
									style: {
										width: '100%',
										minWidth: 240
									}
								}}
								label="Check number"
								onChange={(e) => setEntry({ ...entry, transaction_id: e.target.value })}
							/>
						) : null}

						<div style={{ width: '100%', paddingTop: 10, paddingBottom: 16 }}>
							<Button
								variant="filled"
								color="secondary"
								onClick={chargeAccount}
								disabled={disabledCozDateBefore || isChargeDisabled || missingTransactionId}
								style={{
									height: 38,
									borderRadius: 19,
									paddingLeft: 16,
									paddingRight: 16,
									color: gray[100],
									backgroundColor: purple[500],
									opacity:
										disabledCozDateBefore || isChargeDisabled || missingTransactionId ? 0.6 : 1
								}}>
								{/* if total 0 then Add Day Pass else Charge Account */}
								{entry.charge_type === 'Point of Sale'
									? 'Apply Access Method'
									: total === 0
									? 'Add Day Pass'
									: 'Charge Account'}
							</Button>
						</div>
					</div>
					<div className={classes.receipt}>{getSummary()}</div>
				</div>
			</div>
		)
	}

	const subTotal = () => {
		if (!duesNeeded.length) {
			if (!entry.access_type && checkIn?.pets?.length > 0) return -1
		}
		let price = 0
		let add_price = 0
		if (checkIn?.pets?.length > 0 && needsPass) {
			if (entry.access_type) {
				if (entry.access_type === 'day_pass') {
					const { day_pass_price, additional_pet_price } = dayPassPrice
					add_price = additional_pet_price
					price = day_pass_price
				} else {
					add_price = membershipTypes.find((m) => m.type === entry.access_type).additional_pet_fee
					price = membershipTypes.find((m) => m.type === entry.access_type).price
				}
			}
		}

		let newNum = entry.number ? entry.number - 1 : 0
		let add = add_price * newNum
		let total = price + add

		if (validMemberships.length && guestDogsArr.length) {
			total += 500 * guestDogsArr.length
		}

		return total
	}

	const getAppliedPromoTotal = () => {
		if (!appliedPromo && !appliedManualDiscount) {
			return 0
		}

		const subtotal = subTotal()

		if (appliedPromo) {
			const amountToApply = calculatePromoAmountToApply({
				promo: appliedPromo,
				total: subtotal,
				service_target: PROMO_SERVICE_TARGETS.BAR_PARK
			})
			return amountToApply
		}

		if (appliedManualDiscount) {
			return appliedManualDiscount.amount
		}
	}

	const getTotal = () => {
		// if (!duesNeeded.length) {
		// 	if (!entry.access_type && checkIn?.pets?.length > 0) return '-'
		// }
		// let price = 0
		// let add_price = 0
		// if (checkIn?.pets?.length > 0 && needsPass) {
		// 	if (entry.access_type) {
		// 		if (entry.access_type === 'day_pass') {
		// 			const { day_pass_price, additional_pet_price } = dayPassPrice
		// 			add_price = additional_pet_price
		// 			price = day_pass_price
		// 			if (appliedPromo && appliedPromo.is_free) {
		// 				add_price = 0
		// 				price = 0
		// 			}
		// 		} else {
		// 			add_price = membershipTypes.find((m) => m.type === entry.access_type).additional_pet_fee
		// 			price = membershipTypes.find((m) => m.type === entry.access_type).price
		// 		}
		// 	}
		// }
		// let newNum = entry.number ? entry.number - 1 : 0
		// let add = add_price * newNum
		let total = subTotal()
		total += getAppliedPromoTotal()

		if (duesNeeded.length) {
			total += duesNeeded.length * 100
		}

		return { label: `$${(total / 100).toFixed(2)}`, value: total }
	}

	const additionalPetPrice = useMemo(() => {
		if (!entry.access_type) return '-'
		let price = 0
		if (entry.access_type === 'day_pass') {
			price = dayPassPrice.additional_pet_price
		} else {
			price = membershipTypes.find((m) => m.type === entry.access_type).additional_pet_fee
		}

		return `$${(price / 100).toFixed(2)}`
	}, [dayPassPrice, entry, membershipTypes])

	const accessPrice = useMemo(() => {
		if (!entry.access_type) return '-'
		let price = 0
		if (entry.access_type === 'day_pass') {
			price = dayPassPrice.day_pass_price
		} else {
			price = membershipTypes.find((m) => m.type === entry.access_type).price
		}

		return `$${(price / 100).toFixed(2)}`
	}, [dayPassPrice, entry, membershipTypes])

	const getSummary = () => {
		let payingForPassOrMembership = needsPass ? true : false

		return (
			<div className={classes.summaryContainer}>
				<div className={classes.summaryHeaderContainer}>
					<Typography variant="body2" className={classes.summaryHeader}>
						Summary
					</Typography>
				</div>
				<div className={classes.row}>
					<div className={classes.col1}>
						<Typography variant="body2" className={classes.rowHeader}>
							ITEM
						</Typography>
					</div>
					<div className={classes.col2}>
						<Typography variant="body2" className={classes.rowHeader}>
							QTY
						</Typography>
					</div>
					<div className={classes.col3}>
						<Typography variant="body2" className={classes.rowHeader}>
							COST
						</Typography>
					</div>
				</div>
				{checkIn?.pets?.length > 0 && payingForPassOrMembership && (
					<div className={classes.row}>
						<div className={classes.col1}>
							<Typography variant="body2" className={classes.rowText}>
								Day Pass -
							</Typography>
						</div>
						<div className={classes.col2}>
							<Typography variant="body2" className={classes.rowText}>
								1x
							</Typography>
						</div>
						<div className={classes.col3}>
							<Typography variant="body2" className={classes.rowText}>
								{accessPrice}
							</Typography>
						</div>
					</div>
				)}
				{entry.number > 1 && !hasDayPass ? (
					<div className={classes.row}>
						<div className={classes.col1}>
							<Typography variant="body2" className={classes.rowText}>
								Additional Pets
							</Typography>
						</div>
						<div className={classes.col2}>
							<Typography variant="body2" className={classes.rowText}>
								{entry.number - 1}x
							</Typography>
						</div>
						<div className={classes.col3}>
							<Typography variant="body2" className={classes.rowText}>
								{additionalPetPrice}
							</Typography>
						</div>
					</div>
				) : null}
				{validMemberships.length && guestDogsArr.length ? (
					<div className={classes.row}>
						<div className={classes.col1}>
							<Typography variant="body2" className={classes.rowText}>
								Guest Pass
							</Typography>
						</div>
						<div className={classes.col2}>
							<Typography variant="body2" className={classes.rowText}>
								{guestDogsArr.length}x
							</Typography>
						</div>
						<div className={classes.col3}>
							<Typography variant="body2" className={classes.rowText}>
								${5 * guestDogsArr.length}
							</Typography>
						</div>
					</div>
				) : null}
				{!appliedPromo ? null : (
					<div className={classes.row}>
						<div className={classes.col1} style={{ display: 'flex', gap: '.5rem' }}>
							<Typography variant="body2" className={classes.rowText}>
								{appliedPromo.code.toUpperCase()}
							</Typography>
							<Button
								variant="text"
								disabled={disabledCozDateBefore}
								onClick={() => setAppliedPromo(null)}
								style={{ paddingLeft: 0, paddingTop: 0 }}>
								<Typography
									variant="body2"
									style={{
										fontSize: 14,
										color: gray[900],
										textDecoration: 'underline',
										lineHeight: '24px'
									}}>
									Remove
								</Typography>
							</Button>
						</div>
						<div className={classes.col2}>{NON_BREAKING_SPACE}</div>
						<div className={classes.col3}>
							<Typography variant="body2" className={classes.rowText}>
								{`$${(getAppliedPromoTotal() / 100).toFixed(2)}`}
							</Typography>
						</div>
					</div>
				)}
				{!appliedManualDiscount ? null : (
					<div className={classes.row}>
						<div className={classes.col1} style={{ display: 'flex', gap: '.5rem' }}>
							<Typography variant="body2" className={classes.rowText}>
								{appliedManualDiscount.description}
							</Typography>
							<Button
								variant="text"
								disabled={disabledCozDateBefore}
								onClick={() => setAppliedManualDiscount(null)}
								style={{ paddingLeft: 0, paddingTop: 0 }}>
								<Typography
									variant="body2"
									style={{
										fontSize: 14,
										color: gray[900],
										textDecoration: 'underline',
										lineHeight: '24px'
									}}>
									Remove
								</Typography>
							</Button>
						</div>
						<div className={classes.col2}>{NON_BREAKING_SPACE}</div>
						<div className={classes.col3}>
							<Typography variant="body2" className={classes.rowText}>
								{`$${(getAppliedPromoTotal() / 100).toFixed(2)}`}
							</Typography>
						</div>
					</div>
				)}
				<div
					style={{
						width: '100%',
						paddingTop: 8,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'flex-start'
					}}>
					<Typography
						variant="body2"
						style={{
							fontSize: 16,
							fontWeight: '600',
							color: gray[900],
							lineHeight: '22px'
						}}>
						Total
					</Typography>
					<Typography
						variant="body2"
						style={{
							fontSize: 16,
							fontWeight: '600',
							color: gray[900],
							lineHeight: '22px'
						}}>
						{getTotal().label}
					</Typography>
				</div>
			</div>
		)
	}

	const _removeAccount = async (account) => {
		try {
			removeAccount({
				account_id: account._id,
				checkin_id: checkIn._id
			})
		} catch (e) {
			console.log('big one...', e)
		}
	}

	const _removePet = (pet) => {
		try {
			removePet({
				pet_id: pet._id,
				checkin_id: checkIn._id
			})
		} catch (e) {
			console.log('big one...', e)
		}
	}

	const _removeGuest = (guest) => {
		try {
			removeGuest({
				guest: guest.name,
				guest_id: guest._id,
				checkin_id: checkIn._id
			})
		} catch (e) {
			console.log('big one...', e)
		}
	}

	const getErrors = () => {
		const { needsPass } = validateNoPassCheckIn(checkIn, shouldChargeForFirstCheckin)

		if (!checkIn) {
			return null
		}

		if (chargeSuccess) {
			return (
				<div
					style={{
						width: '100%',
						backgroundColor: gray[100]
					}}>
					<div
						style={{
							width: '100%',
							backgroundColor: 'rgba(76, 175, 80, 0.1)',
							display: 'flex',
							padding: 16,
							paddingLeft: 36,
							flexDirection: 'row',
							justifyContent: 'flex-start',
							alignItems: 'center'
						}}>
						<Icon
							className="fa fa-check-circle"
							style={{
								fontSize: '11px',
								color: '#4CAF50',
								marginRight: 16
							}}
						/>
						<Typography
							variant="body2"
							style={{
								fontSize: 16,
								color: '#2E7B32'
							}}>
							Account successfully charged
						</Typography>
					</div>
				</div>
			)
		}

		if (
			(needsPass || duesNeeded.length) &&
			!checkIn.checked_in &&
			cardsLoaded &&
			!cards.length &&
			entry.charge_type === 'Charge Account'
		)
			return (
				<div
					style={{
						width: '100%',
						backgroundColor: gray[100]
					}}>
					<div
						style={{
							width: '100%',
							backgroundColor: 'rgba(235, 76, 76, 0.1)',
							display: 'flex',
							padding: 16,
							paddingLeft: 36,
							flexDirection: 'row',
							justifyContent: 'flex-start',
							alignItems: 'center'
						}}>
						<Icon
							className="fa fa-exclamation-circle"
							style={{
								fontSize: '11px',
								color: errors[500],
								marginRight: 16
							}}
						/>
						<Typography
							variant="body2"
							style={{
								fontSize: 16,
								color: errors[900]
							}}>
							No payment method on file. Add a card on the payments page, or select the POS option.
						</Typography>
					</div>
				</div>
			)

		if (
			validMemberships.length &&
			checkIn.pets.length &&
			checkIn.memberships[0].number_of_pets < checkIn.pets.length &&
			showNumDogs
		)
			return (
				<div
					style={{
						width: '100%',
						backgroundColor: gray[100]
					}}>
					<div
						style={{
							width: '100%',
							backgroundColor: 'rgba(249, 168, 37, 0.1)',
							display: 'flex',
							padding: 16,
							paddingLeft: 36,
							flexDirection: 'row',
							justifyContent: 'flex-start',
							alignItems: 'center'
						}}>
						<Icon
							className="fa fa-exclamation-circle"
							style={{
								fontSize: '11px',
								color: ' #B26200',
								marginRight: 16
							}}
						/>
						<Typography
							variant="body2"
							style={{
								fontSize: 16,
								color: ' #B26200'
							}}>
							This membership currently only covers {checkIn.memberships[0].number_of_pets} of the{' '}
							{checkIn.pets.length} dogs listed.
						</Typography>
					</div>
				</div>
			)
	}

	const getCheckInActions = () => {
		const missingLocalGuestToBeSigned = !!(
			checkIn.guests &&
			checkIn.guests.length &&
			checkIn.guests.find((g) => !g.signed_waiver)
		)

		let newGuestToBeCheckedIn = false
		const guestsLocal = checkIn?.guests || []
		const guestsDB = checkIn?.checked_in_guests || []
		if (guestsLocal.length !== guestsDB.length) {
			newGuestToBeCheckedIn = true
		} else {
			for (const gl of guestsLocal) {
				const guestRemote = guestsDB.find((gb) => gb.name === gl.name)
				if (!guestRemote) newGuestToBeCheckedIn = true
				if (guestRemote.signed_waiver !== gl.signed_waiver) newGuestToBeCheckedIn = true
			}
		}

		const completed = checkIn.checked_in !== undefined && !!checkIn.checked_in
		const neverCheckedIn = checkIn.checked_in === undefined

		if (neverCheckedIn) {
			if (missingLocalGuestToBeSigned || checkIn.hasIssues) {
				return (
					<DialogActions className={classes.dialogActions}>
						<Button
							variant="solid"
							color="secondary"
							style={{
								padding: '15px',
								paddingTop: '5px',
								paddingBottom: '5px',
								backgroundColor: purple[500],
								height: 38,
								borderRadius: 19,
								paddingLeft: 18,
								paddingRight: 18,
								color: gray[100],
								fontSize: 14,
								opacity: needsPass || duesNeeded.length ? 0.6 : 1,
								letterSpacing: 1.25
							}}
							disabled={needsPass || duesNeeded.length ? true : false}
							onClick={() => {
								setIsShown(false)
								setCardsLoaded(false)
								setCards([])
								setEntry({
									charge_type: '',
									access_type: '',
									number: ''
								})
								setAppliedPromo(null)
								setAppliedManualDiscount(null)
								completeBadCheckIn()
							}}>
							CHECK IN ANYWAY
						</Button>
						<Button
							variant="outlined"
							disabled={disabledCozDateBefore}
							onClick={() => refreshList()}
							color="secondary">
							Refresh
						</Button>
					</DialogActions>
				)
			} else {
				return (
					<DialogActions className={classes.dialogActions}>
						<Button
							variant="solid"
							color="primary"
							style={{
								padding: '15px',
								paddingTop: '5px',
								paddingBottom: '5px',
								backgroundColor: purple[500],
								opacity: needsPass || duesNeeded.length || disabledCozDateBefore ? 0.6 : 1,
								height: 38,
								borderRadius: 19,
								paddingLeft: 18,
								paddingRight: 18,
								color: gray[100],
								fontSize: 14,
								letterSpacing: 1.25
							}}
							disabled={needsPass || duesNeeded.length || disabledCozDateBefore}
							onClick={() => {
								setIsShown(false)
								setCardsLoaded(false)
								setCards([])
								setEntry({
									charge_type: '',
									access_type: '',
									number: ''
								})
								setAppliedPromo(null)
								setAppliedManualDiscount(null)
								updateAccessMethodAndCheckIn()
							}}>
							CHECK IN
						</Button>
						<Button
							variant="outlined"
							disabled={disabledCozDateBefore}
							onClick={() => refreshList()}
							color="secondary">
							Refresh
						</Button>
					</DialogActions>
				)
			}
		}

		// has already checkedIn
		if (completed) {
			if (newGuestToBeCheckedIn && missingLocalGuestToBeSigned) {
				return (
					<DialogActions className={classes.dialogActions}>
						<Button
							variant="solid"
							color="secondary"
							style={{
								padding: '15px',
								paddingTop: '5px',
								paddingBottom: '5px',
								backgroundColor: purple[500],
								height: 38,
								borderRadius: 19,
								paddingLeft: 18,
								paddingRight: 18,
								color: gray[100],
								fontSize: 14,
								opacity: needsPass || duesNeeded.length ? 0.6 : 1,
								letterSpacing: 1.25
							}}
							disabled={needsPass || duesNeeded.length ? true : false}
							onClick={() => {
								setIsShown(false)
								setCardsLoaded(false)
								setCards([])
								setEntry({
									charge_type: '',
									access_type: '',
									number: ''
								})
								setAppliedPromo(null)
								setAppliedManualDiscount(null)
								completeBadCheckIn()
								// completeCheckIn(checkIn);
							}}>
							CHECK IN ANYWAY
						</Button>
						<Button
							variant="outlined"
							disabled={disabledCozDateBefore}
							onClick={() => refreshList()}
							color="secondary">
							Refresh
						</Button>
					</DialogActions>
				)
			} else {
				return (
					<DialogActions className={classes.dialogActions}>
						<Button
							variant="solid"
							color="primary"
							style={{
								padding: '15px',
								paddingTop: '5px',
								paddingBottom: '5px',
								backgroundColor: purple[500],
								opacity:
									needsPass ||
									duesNeeded.length ||
									disabledCozDateBefore ||
									!newGuestToBeCheckedIn
										? 0.6
										: 1,
								height: 38,
								borderRadius: 19,
								paddingLeft: 18,
								paddingRight: 18,
								color: gray[100],
								fontSize: 14,
								letterSpacing: 1.25
							}}
							disabled={
								needsPass || duesNeeded.length || disabledCozDateBefore || !newGuestToBeCheckedIn
							}
							onClick={() => {
								setIsShown(false)
								setCardsLoaded(false)
								setCards([])
								setEntry({
									charge_type: '',
									access_type: '',
									number: ''
								})
								setAppliedPromo(null)
								setAppliedManualDiscount(null)
								updateAccessMethodAndCheckIn()
							}}>
							{newGuestToBeCheckedIn ? 'CHECK IN' : 'CHECKED IN'}
						</Button>
						<Button
							variant="outlined"
							disabled={disabledCozDateBefore}
							onClick={() => refreshList()}
							color="secondary">
							Refresh
						</Button>
					</DialogActions>
				)
			}
		}
	}

	const findExpiringVaccines = (pet) => {
		if (pet.vaccines) {
			return pet.vaccines
				.filter((vaccine) => {
					return (
						moment(vaccine.expiration_date).isBefore(moment().add(30, 'days').startOf('day')) &&
						!moment(vaccine.expiration_date).isBefore(moment().startOf('day'))
					)
				})
				.map((v) => v.type)
		}

		return []
	}

	const resetAll = () => {
		setIsShown(false)
		unselect()
		setCardsLoaded(false)
		setCards([])
		setEntry({
			charge_type: PAYMENT_TYPES[0],
			access_type: 'day_pass',
			number: numDogs
		})
		setAppliedPromo(null)
		setAppliedManualDiscount(null)
		setCodeOnCheckIn(null)
	}

	const renderNotes = (pet) => {
		let facilityPet
		let expiringVaccines
		let isLoading = true

		if (pet && isShown) {
			facilityPet = petsInFacility.find((facilityPet) => facilityPet.pet_id === pet._id)
			expiringVaccines = findExpiringVaccines(pet)
			isLoading = false
		}

		return isLoading ? (
			<div>
				<Typography className={classes.eligibilityText} style={{ marginTop: '16px' }}>
					Notes
				</Typography>
				<Note loading={true} />
			</div>
		) : facilityPet || expiringVaccines.length > 0 ? (
			<div>
				<Typography className={classes.eligibilityText} style={{ marginTop: '16px' }}>
					Notes
				</Typography>
				<Note type={facilityPet ? facilityPet.visitType : null} expiringVaccines={expiringVaccines} />
			</div>
		) : null
	}

	const handlePromoDiscountOnComplete = (data) => {
		const { validated_promo, manual_discount } = data
		if (validated_promo) {
			dispatch(showSuccess('Promo Validated!'))
			setAppliedPromo(validated_promo)
			setAppliedManualDiscount(null)
			setShowPromoDiscountEntry(false)
		}
		if (manual_discount) {
			dispatch(showSuccess('Discount Applied!'))
			setAppliedManualDiscount(manual_discount)
			setAppliedPromo(null)
			setShowPromoDiscountEntry(false)
		}
	}

	const guestDogsArr = useMemo(() => {
		if (!checkIn || !checkIn.guests) return []
		const dogs = []
		checkIn.guests.forEach((g) => {
			if (g.dogs?.length) {
				dogs.push(...g.dogs)
			}
		})

		return dogs
	}, [checkIn])

	return (
		<>
			<Dialog
				open={isShown}
				className={classes.dialog}
				onClose={() => resetAll()}
				PaperProps={{
					style: {
						width: 920,
						maxWidth: 920,
						minHeight: 500,
						maxHeight: 700,
						padding: 0
					}
				}}>
				{singleLoading ? <LoadingOverlay /> : null}
				<div style={{ width: '100%' }}>
					<div style={{ padding: '24px', paddingBottom: getErrors() ? 16 : 0 }}>
						<DialogTitle className={classes.reportHeader} style={{ marginBottom: 0 }}>
							CHECK IN
						</DialogTitle>
						<span className={classes.close} onClick={() => resetAll()}>
							X
						</span>
					</div>
					{getErrors()}
				</div>
				<DialogContent style={{ padding: '24px' }}>
					<div className={classes.visitorContainer}>
						{checkIn.accounts
							? checkIn.accounts
									.filter((account) =>
										!checkIn.checked_in
											? true
											: checkIn.checked_in_accounts.includes(account._id)
									)
									.map((account) => {
										let { issues } = account
										let image_link =
											(account.ID_info && account.ID_info.image_link) || account.image_url

										return (
											<div className={classes.visitor}>
												{(account.ID_info && account.ID_info.image_link) ||
												account.image_url ? (
													<div
														className={classes.visitorImage}
														style={{
															backgroundImage: `url(${
																image_link && !image_link.includes('http')
																	? `https://${image_link}`
																	: image_link
															})`,
															backgroundSize: 'cover',
															backgroundPosition: '50% 50%'
														}}></div>
												) : (
													<div className={classes.visitorPicture}>
														<AccountCircle
															style={{
																fill: 'rgba(255,255,255,1.0)',
																fontSize: '32px'
															}}
														/>
													</div>
												)}
												<div className={classes.vistorDetails}>
													<div className={classes.vistorName}>
														<Icon
															className="fa fa-user"
															style={{
																fontSize: '11px',
																color: purple[500]
															}}
														/>{' '}
														<a
															href={`/clients/${account.household}/contacts`}
															target="_blank"
															style={{
																textDecoration: 'none',
																marginLeft: '8px',
																color: purple[500],
																fontSize: '16px',
																fontWeight: '800'
															}}>
															{account.full_name}
														</a>
													</div>
													<Typography className={classes.vistorSubtitle}>
														{account.phone_number}
													</Typography>
													<Typography className={classes.vistorSubtitle}>
														{account.email}
													</Typography>
													{account.short_id ? (
														<Typography className={classes.vistorSubtitle}>
															{account.short_id}
														</Typography>
													) : null}
												</div>
												<div className={classes.visitorEligibility}>
													<Typography className={classes.eligibilityText}>
														Eligibility
													</Typography>
													{issues.length ? (
														issues.map((i) => {
															return <Issue message={i.message} />
														})
													) : (
														<Chip
															label={
																<Icon
																	className="fas fa-check"
																	style={{ fontSize: '15px', fill: '#2E7B32' }}
																/>
															}
															className={classes.chip}
															style={{
																...getChipStyles('success'),
																paddingTop: '6px',
																marginTop: 8
															}}
														/>
													)}
												</div>
												<div className={classes.vistorRemove}>
													{checkIn.accounts.length > 1 && !checkIn.checked_in ? (
														<Button
															onClick={() => _removeAccount(account)}
															disabled={disabledCozDateBefore}
															variant="outlined"
															style={{
																fontFamily: 'Nunito',
																color: purple[500],
																borderColor: purple[500]
															}}>
															REMOVE
														</Button>
													) : null}
												</div>
											</div>
										)
									})
							: null}
						{checkIn.pets
							? checkIn.pets
									.filter((pet) =>
										!checkIn.checked_in ? true : checkIn.checked_in_pets.includes(pet._id)
									)
									.map((pet) => {
										let { issues } = pet
										return (
											<div className={classes.visitor}>
												{pet.image_url &&
												pet.image_url !=
													'https://waggle-keys-stage.s3.amazonaws.com/pet-placeholder.jpg' ? (
													<div className={classes.visitorPicture}>
														<img src={pet.image_url} className={classes.pic} />
													</div>
												) : (
													<div className={classes.visitorPicture}>
														<Pets
															style={{
																fill: 'rgba(255,255,255,1.0)',
																fontSize: '32px'
															}}
														/>
													</div>
												)}
												<div className={classes.vistorDetails}>
													<div className={classes.vistorName}>
														<Icon
															className="fa fa-dog"
															style={{
																fontSize: '11px',
																color: purple[500]
															}}
														/>{' '}
														<a
															href={`/clients/${pet.household_id}/pets/${pet._id}`}
															target="_blank"
															style={{
																marginLeft: '8px',
																color: purple[500],
																fontSize: '16px',
																fontWeight: '800',
																textDecoration: 'none'
															}}
															onClick={(e) => e.stopPropagation()}>
															{pet.name + ' '}{' '}
															{pet.sex
																? pet.sex == 'Intact Male' ||
																  pet.sex == 'Neutered Male'
																	? '(M)'
																	: pet.sex == 'Intact Female' ||
																	  pet.sex == 'Spayed Female'
																	? '(F)'
																	: ''
																: ''}
														</a>
													</div>
													<Typography className={classes.vistorSubtitle}>{}</Typography>
													<Typography className={classes.vistorSubtitle}>{}</Typography>
												</div>
												<div className={classes.visitorEligibility}>
													<Typography className={classes.eligibilityText}>
														Eligibility
													</Typography>
													{issues.length ? (
														issues.map((i) => (
															<Issue message={i.message} type={i.type} />
														))
													) : (
														<Chip
															label={
																<Icon
																	className="fas fa-check"
																	style={{ fontSize: '15px', fill: '#2E7B32' }}
																/>
															}
															className={classes.chip}
															style={{
																...getChipStyles('success'),
																paddingTop: '6px',
																marginTop: 8
															}}
														/>
													)}
													{renderNotes(pet)}
												</div>
												<div className={classes.vistorRemove}>
													{!checkIn.checked_in && (
														<Button
															onClick={() => _removePet(pet)}
															disabled={disabledCozDateBefore}
															variant="outlined"
															style={{
																fontFamily: 'Nunito',
																color: purple[500],
																borderColor: purple[500]
															}}>
															REMOVE
														</Button>
													)}
												</div>
											</div>
										)
									})
							: null}
						{checkIn.guests
							? checkIn.guests.map((guest) => {
									const { issues } = guest

									return (
										<div className={classes.visitor}>
											<div className={classes.visitorPictureGuest}>
												<Typography className={classes.guestText}>Guest</Typography>
											</div>
											<div className={classes.vistorDetails}>
												<div className={classes.vistorName}>
													<Icon
														className="fa fa-user"
														style={{
															fontSize: '11px',
															color: gray[900]
														}}
													/>{' '}
													<Typography
														style={{
															marginLeft: '8px',
															color: gray[900],
															fontSize: '16px',
															fontWeight: '800'
														}}>
														{guest.name}
													</Typography>
												</div>
											</div>
											{guest._id ? (
												<div className={classes.visitorEligibility}>
													<Typography className={classes.eligibilityText}>
														Eligibility
													</Typography>
													{issues.length ? (
														issues.map((i) => {
															return <Issue message={i.message} />
														})
													) : (
														<Chip
															label={
																<Icon
																	className="fas fa-check"
																	style={{ fontSize: '15px', fill: '#2E7B32' }}
																/>
															}
															className={classes.chip}
															style={{
																...getChipStyles('success'),
																paddingTop: '6px',
																marginTop: 8
															}}
														/>
													)}
												</div>
											) : (
												<div className={classes.visitorEligibility}>
													<Typography className={classes.eligibilityText}>
														Eligibility
													</Typography>
													<div
														style={{
															display: 'flex',
															flexDirection: 'row',
															justifyContent: 'flex-start',
															alignItems: 'center'
														}}>
														<Checkbox
															checked={guest.signed_waiver ? true : false}
															disabled={disabledCozDateBefore}
															onClick={() => {
																dispatch(guestSigned(guest, checkIn))
															}}
														/>
														<Typography
															style={{
																color: gray[900],
																fontSize: 16,
																fontWeight: '600'
															}}>
															Verified Photo ID & Signed Waiver
														</Typography>
													</div>
												</div>
											)}
											<div className={classes.vistorRemove}>
												{!checkIn.checked_in && (
													<Button
														onClick={() => _removeGuest(guest)}
														disabled={disabledCozDateBefore}
														variant="outlined"
														style={{
															fontFamily: 'Nunito',
															color: purple[500],
															borderColor: purple[500]
														}}>
														REMOVE
													</Button>
												)}
											</div>
										</div>
									)
							  })
							: null}
						{guestDogsArr.map((pet) => {
							let { issues } = pet
							return (
								<div className={classes.visitor}>
									{pet.image_url &&
									pet.image_url !=
										'https://waggle-keys-stage.s3.amazonaws.com/pet-placeholder.jpg' ? (
										<div className={classes.visitorPicture}>
											<img src={pet.image_url} className={classes.pic} />
										</div>
									) : (
										<div className={classes.visitorPicture}>
											<Pets
												style={{
													fill: 'rgba(255,255,255,1.0)',
													fontSize: '32px'
												}}
											/>
										</div>
									)}
									<div className={classes.vistorDetails}>
										<div className={classes.vistorName}>
											<Icon
												className="fa fa-dog"
												style={{
													fontSize: '11px',
													color: purple[500]
												}}
											/>{' '}
											<a
												href={`/clients/${pet.household_id}/pets/${pet._id}`}
												target="_blank"
												style={{
													marginLeft: '8px',
													color: purple[500],
													fontSize: '16px',
													fontWeight: '800',
													textDecoration: 'none'
												}}
												onClick={(e) => e.stopPropagation()}>
												{pet.name + ' '}{' '}
												{pet.sex
													? pet.sex == 'Intact Male' || pet.sex == 'Neutered Male'
														? '(M)'
														: pet.sex == 'Intact Female' || pet.sex == 'Spayed Female'
														? '(F)'
														: ''
													: ''}
											</a>
										</div>
										<Typography className={classes.vistorSubtitle}>{}</Typography>
										<Typography className={classes.vistorSubtitle}>{}</Typography>
									</div>
									<div className={classes.visitorEligibility}>
										<Typography className={classes.eligibilityText}>Eligibility</Typography>
										{issues.length ? (
											issues.map((i) => <Issue message={i.message} type={i.type} />)
										) : (
											<Chip
												label={
													<Icon
														className="fas fa-check"
														style={{ fontSize: '15px', fill: '#2E7B32' }}
													/>
												}
												className={classes.chip}
												style={{
													...getChipStyles('success'),
													paddingTop: '6px',
													marginTop: 8
												}}
											/>
										)}
										{renderNotes(pet)}
									</div>
									<div className={classes.vistorRemove}>
										{!checkIn.checked_in && (
											<Button
												onClick={() => _removePet(pet)}
												disabled={disabledCozDateBefore}
												variant="outlined"
												style={{
													fontFamily: 'Nunito',
													color: purple[500],
													borderColor: purple[500]
												}}>
												REMOVE
											</Button>
										)}
									</div>
								</div>
							)
						})}
						<div
							style={{
								width: '100%'
							}}>
							<Button
								variant="text"
								disabled={disabledCozDateBefore}
								style={{
									width: '100%',
									flexDirection: 'row',
									justifyContent: 'space-between',
									backgroundColor: gray[200],
									alignItems: 'center',
									opacity: disabledCozDateBefore ? 0.6 : 1
								}}
								onClick={() => openMenu(!menuOpen)}>
								<Typography
									variant="body2"
									style={{
										textTransform: 'capitalize',
										fontSize: 16,
										color: gray[900],
										fontWeight: 'bold'
									}}>
									Add Visitor
								</Typography>
								<Icon
									className={menuOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}
									style={{
										color: gray[700],
										fontSize: 16
									}}
								/>
							</Button>

							{menuOpen ? (
								<div
									style={{
										backgroundColor: gray[200],
										width: '100%',
										padding: 16
									}}>
									<div
										style={{
											display: 'flex',
											width: '100%',
											flexDirection: 'row',
											justifyContent: 'space-between',
											marginBottom: 12
										}}>
										<TextField
											variant="filled"
											disabled={disabledCozDateBefore}
											value={visitor_type || ''}
											label="Type"
											select
											style={{ width: '48%', marginBottom: 16, minWidth: 5 }}
											onChange={(e) => {
												setVisitorType(e.target.value)
												setNewVisitor()
											}}
											InputProps={{
												style: {
													width: '100%',
													minWidth: 240
												}
											}}>
											{visitorOptions
												.filter((o) => {
													console.log('o', o)
													if (validMemberships.length) return true
													if (o === 'Guest (with Dog)') return false
													return true
												})
												.map((option, index) => (
													<MenuItem key={option} value={option} selected={index === 0}>
														{option}
													</MenuItem>
												))}
										</TextField>
										{getAddVisitorSelector()}
									</div>
									{visitor_type === 'Guest (with Dog)' && (
										<div style={{ marginBottom: 24 }}>
											<CheckInAutocomplete
												setGuest={setGuest}
												setGuestDogs={setGuestDogs}
												guest={humanGuest}
												guestDogs={guestDogs}
											/>
										</div>
									)}
									<div
										style={{
											display: 'flex',
											width: '100%',
											flexDirection: 'row',
											justifyContent: 'space-between',
											alignItems: 'center',
											marginBottom: 12
										}}>
										<div>
											<Button
												variant="solid"
												disabled={disabledCozDateBefore}
												color="secondary"
												style={{
													padding: '15px',
													paddingTop: '5px',
													paddingBottom: '5px',
													backgroundColor: purple[500],
													height: 38,
													borderRadius: 19,
													paddingLeft: 18,
													paddingRight: 18,
													color: gray[100],
													fontSize: 14,
													letterSpacing: 1.25,
													marginRight: 16
												}}
												onClick={() => {
													if (visitor_type === 'Guest (with Dog)' && humanGuest?._id) {
														addNewVisitor({
															checkin_id: checkIn._id,
															guests_with_dogs: [
																{
																	_id: humanGuest.account._id,
																	household_id: humanGuest._id,
																	name: humanGuest.account.full_name,
																	pet_ids: guestDogs
																}
															],
															type: visitor_type.toLowerCase()
														})

														openMenu(false)
														setVisitorType('Contact')
														setGuest()
														setGuestDogs([])
														setNewVisitor()
													} else {
														addNewVisitor({
															...newVisitor,
															type: visitor_type.toLowerCase(),
															checkin_id: checkIn._id
														})
														openMenu(false)
														setVisitorType('Contact')
														setNewVisitor()
													}
												}}>
												ADD VISITOR
											</Button>
											<Button
												variant="outlined"
												disabled={disabledCozDateBefore}
												onClick={() => {
													openMenu(false)
													setVisitorType('Contact')
													setNewVisitor()
												}}
												color="secondary">
												Cancel
											</Button>
										</div>
										<Button
											variant="outlined"
											onClick={() => {
												const url = `/clients/create`
												window.open(url, '_blank').focus()
											}}
											color="secondary">
											Create Household
										</Button>
									</div>
								</div>
							) : null}
						</div>
					</div>
					<div className={classes.line} />
					{/*<BarDues checkIn={checkIn} duesNeeded={duesNeeded} />*/}
					<AccessMethod
						checkIn={checkIn}
						setEntry={setEntry}
						entry={entry}
						facility={facility}
						isVipTrial={isVipTrial}
						needsPass={needsPass}
						hasDayPass={hasDayPass}
						guestDogs={guestDogsArr}
						validMemberships={validMemberships}
						shouldChargeForFirstCheckIn={shouldChargeForFirstCheckin}
						numDogs={numDogs}
					/>
					{!isVipTrial && needsPass && numDogs > 0 && !appliedPromo && !appliedManualDiscount ? (
						<div>
							<Button
								variant="text"
								disabled={appliedPromo}
								onClick={handleShowPromoDiscountEntryDialog}
								className={classes.addPromoDiscountButton}>
								ADD PROMO OR DISCOUNT
							</Button>
						</div>
					) : null}
					{showParkingSection ? (
						<>
							<div className={classes.line} />
							<Parking
								validMemberships={validMemberships}
								checkIn={checkIn}
								getCode={getCode}
								parking_codes={parking_codes}
								setCodeOnCheckIn={setCodeOnCheckIn}
							/>
						</>
					) : null}

					{/* Payment */}
					{getNewMethod()}
				</DialogContent>
				{getCheckInActions()}
			</Dialog>
			<PromoAndDiscountEntryDialog
				open={showPromoDiscountEntry}
				onCancel={handleHidePromoDiscountEntryDialog}
				onComplete={handlePromoDiscountOnComplete}
				apiAction={PROMO_API_ACTIONS.Validate}
				service_target={PROMO_SERVICE_TARGETS.BAR_PARK}
				household_id={checkIn.household_id || null}
				market_id={facility?.market_id || null}
				price={subTotal()}
			/>
		</>
	)
}

export default CheckInDialog

const Issue = (props) => {
	const classes = useStyles()
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'flex-start',
				alignItems: 'center',
				// backgroundColor: "rgba(249, 168, 37, 0.1)",
				padding: 8,
				paddingLeft: 0
				// borderRadius: 6
			}}>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					backgroundColor: props.type === 'red' ? 'rgba(235, 76, 76, 0.1)' : 'rgba(249, 168, 37, 0.1)',
					padding: 8,
					borderRadius: 6,
					marginRight: 16
				}}>
				<Icon
					className="fa fa-exclamation-triangle"
					style={{
						fontSize: '11px',
						color: props.type === 'red' ? purple[500] : '#B26200'
					}}
				/>
			</div>
			<Typography
				style={{
					color: props.type === 'red' ? purple[500] : '#B26200',
					fontSize: 16,
					fontWeight: '600'
				}}>
				{props.message}
			</Typography>
		</div>
	)
}

const Note = (props) => {
	const classes = useStyles()
	let { loading, type, expiringVaccines } = props
	let items = []

	if (type) items.push({ type: 'location', name: type })
	if (expiringVaccines && expiringVaccines.length > 0)
		expiringVaccines.forEach((v) => items.push({ type: 'vaccine', name: v }))

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'flex-start',
				// backgroundColor: "rgba(249, 168, 37, 0.1)",
				padding: 8,
				paddingLeft: 0
				// borderRadius: 6
			}}>
			{loading ? (
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'center',
							background: 'rgba(26, 26, 53, 0.05)',
							padding: 8,
							borderRadius: 6,
							width: '35px',
							marginRight: 16
						}}>
						<Icon
							className="fa fa-redo"
							style={{
								fontSize: '11px',
								color: gray[800]
							}}
						/>
					</div>
					<Typography
						style={{
							color: gray[800],
							fontSize: 16,
							fontWeight: '600',
							textTransform: 'capitalize'
						}}>
						Loading ...
					</Typography>
				</div>
			) : (
				items.map((i) => {
					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								marginBottom: '8px'
							}}>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									alignItems: 'center',
									background: 'rgba(26, 26, 53, 0.05)',
									padding: 8,
									borderRadius: 6,
									marginRight: 16
								}}>
								<Icon
									className="fa fa-info-circle"
									style={{
										fontSize: '11px',
										color: gray[800]
									}}
								/>
							</div>
							<Typography
								style={{
									color: gray[800],
									fontSize: 16,
									fontWeight: '600',
									textTransform: 'capitalize'
								}}>
								{i.type === 'vaccine' ? i.name + ' expires soon' : 'At ' + i.name}
							</Typography>
						</div>
					)
				})
			)}
		</div>
	)
}
